<template>
    <div class="h-100">
        <v-row>
            <v-col class="pt-5">
                <div class="d-flex align-center justify-space-between">
                    <span>{{ $t('eshop::group-filter.filters') }}:</span>
                </div>
            </v-col>
        </v-row>
        <v-row class="position-sticky" style="top: 80px;">
            <v-col v-if="stock_filter && $page.props.eshopEnabled" cols="12" class="pb-1">
                <v-divider class="mb-4" />
                <v-checkbox
                    v-model="store.selectedStock"
                    :value="stock_filter.url"
                    :label="stock_filter.name"
                    @update:modelValue="changeFilter"
                    density="compact"
                    hide-details
                >
                </v-checkbox>
            </v-col>
            <v-col v-for="(param, i) in filter" :key="param.name" cols="12">
                <v-divider class="mb-4" />
                <v-sheet class="h-100">
                    <div v-if="param.slider">
                        <div class="mb-3 font-weight-medium">{{ param.name }}</div>
                        <v-range-slider
                            v-model="store.selected[i]"
                            :min="param.slider.min"
                            :max="param.slider.max"
                            thumb-label
                            hide-details
                            :step="param.key === 'price' ? 10 : 1"
                            @update:modelValue="changeRange"
                        >
                        </v-range-slider>
                        <div class="mt-2 to-warning__static">
                            {{ `${store.selected[i][0]}${param.unit ? ` ${param.unit}` : ''}` }} - {{ `${store.selected[i][1]}${param.unit ? ` ${param.unit}` : ''}` }}
                        </div>
                    </div>
                    <div v-else>
                        <div class="mb-3 font-weight-medium">{{ param.name }}</div>
                        <div class="colors" v-if="param.show_as === 'colors'">
                            <v-btn-toggle
                                v-model="store.selected[i]"
                                @update:modelValue="changeFilter"
                                multiple
                                class="h-auto flex-wrap color-wrap mt-n2 ml-n2 pr-2 pb-2">
                                <v-btn
                                    v-for="val in param.values"
                                    :key="val.id"
                                    :icon="mdiCheck"
                                    class="color-btn pa-0 mt-2 ml-2"
                                    :style="{background: val.show_as || undefined}"
                                    :value="val.url"
                                />
                            </v-btn-toggle>
                        </div>
                        <div v-else-if="param.type === 'flags'">
                            <div class="d-flex flex-column tagsFilter">
                                <v-list
                                    v-model:selected="store.selected[i]"
                                    class="c-filter-menu"
                                    select-strategy="leaf"
                                    @update:selected="changeFilter"
                                >
                                    <v-list-item
                                        v-for="item in param.values"
                                        :key="item.id"
                                        :value="item.url"
                                        :title="item.name"
                                    >
                                        <template v-slot:prepend="{ isSelected, select }">
                                            <v-checkbox-btn :model-value="isSelected" @update:model-value="select"></v-checkbox-btn>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </div>
                        </div>
                        <div v-else-if="param.show_as === 'buttons'">
                            <div class="d-flex flex-column tagsFilter">
                                <v-chip-group v-model="store.selected[i]" @update:modelValue="changeFilter" column multiple>
                                    <v-chip
                                        v-for="item in param.values" :key="item.id"
                                        :text="item.name"
                                        :value="item.url"
                                        variant="outlined"
                                        rounded="lg"
                                        filter
                                    ></v-chip>
                                </v-chip-group>
                            </div>
                        </div>
                        <div v-else class="position-relative">
                            <c-autocomplete
                                :hide-input="!store.filterValueCount[i]"
                                v-model="store.selected[i]"
                                v-model:search="store.valueSearch[i]"
                                :items="filterTextValues[i]"
                                hide-details
                                multiple
                                variant="outlined"
                                :menu-icon="mdiMagnify"
                                close-text="$vuetify.open"
                                density="compact"
                                closable-chips
                                :menu-props="{
                                modelValue: true,
                                class: 'c-filter-menu',
                            }"
                                @update:modelValue="changeFilter(); store.filterValueCount[i] = undefined"
                                @update:search="!$event || $event.length === 0 ? store.filterValueCount[i] = undefined : null"
                            >
                                <template #selection></template>
                                <template #item="{item, props, isPristine, getMatches, highlightResult}">
                                    <v-list-item
                                        v-if="item.raw.title !== 'show_more'"
                                        v-bind="props"
                                        role="option"
                                    >
                                        <template #title>
                                            <template v-if="isPristine || !store.valueSearch[i]">
                                                {{item.raw.title}}
                                            </template>
                                            <template v-else>
                                                <component v-for="(c, i) in highlightResult('v-autocomplete', item.raw.title, getMatches(item)?.title)" :is="c" :key="i"></component>
                                            </template>
                                        </template>
                                        <template #prepend="{isSelected}">
                                            <v-checkbox-btn
                                                :model-value="isSelected"
                                                :ripple="false"
                                                :key="item.value"
                                            ></v-checkbox-btn>
                                        </template>
                                    </v-list-item>
                                    <v-btn
                                        v-else-if="store.filterValueCount[i] && store.filterValueCount[i] !== 'show'"
                                        variant="text"
                                        class="text-subtitle-1"
                                        color="cis-accent-color"
                                        @click="store.filterValueCount[i] = 'show'"
                                    >
                                        + {{ $tChoice('eshop::group-filter.show_more', store.filterValueCount[i], { count: store.filterValueCount[i] }) }}
                                    </v-btn>
                                </template>
                            </c-autocomplete>
                        </div>
                    </div>
                </v-sheet>
            </v-col>
            <v-col v-if="mobile" cols="12" class="d-flex align-center justify-center c-floating-close bg-white">
                <v-btn
                    block
                    color="cis-accent-color"
                    @click="emit('closeFilter')"
                >
                    {{ $t('eshop::global-forms.close_action') }}
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { debounce } from 'lodash-es';
import { buildFilterUrl } from '../../../utils/urlBuilder';
import { mdiCheck, mdiMagnify } from '@mdi/js';
import { useFilterStore } from '../store/filter.js';
import pinia from '../../../plugins/pinia.js';
import { CAutocomplete } from '../../../frontend/components/CAutocomplete.mjs';

const props = defineProps({
    filter: Array,
    stock_filter: Object,
    url: String,
    mobile: Boolean,
});
const emit = defineEmits(['changeFilter', 'closeFilter']);
const store = useFilterStore(pinia);
const url = computed(() => {
    if (usePage().props.group?.url && !usePage().props.manufacturer_group?.slug)
        return usePage().props.group.url;

    if (usePage().props.search?.url)
        return usePage().props.search.url;

    if (usePage().props.manufacturer?.url) {
        const groupSlug = usePage().props.manufacturer_group.slug;
        if (groupSlug === 'skip') {
            return usePage().props.manufacturer.url;
        }
        return usePage().props.manufacturer.url + '/' + usePage().props.manufacturer_group.slug;
    }

    return usePage().url;
});

watch(() => props.filter, val => {
    store.selected = [];
    if (val) {
        for (let i = 0; i < val.length; i++) {
            if (val[i].slider) {
                store.selected[i] = [val[i].slider.chosen_min, val[i].slider.chosen_max];
            } else {
                if (val[i].values) {
                    store.selected[i] = val[i].values.reduce((filtered, item) => {
                        if (item.is_selected) {
                            filtered.push(item.url);
                        }
                        return filtered;
                    }, []);
                }
            }
        }
    }
}, { deep: true, immediate: true });

const filterTextValues = computed(() => {
    const values = [];
    for (let i = 0; i < props.filter.length; i++) {
        if (props.filter[i].type && (props.filter[i].type === 'text' || props.filter[i].type === 'number' && !props.filter[i].slider)) {
            const filterValues = props.filter[i].values;
            let filteredValues = [];
            let substract = false;
            if (store.filterValueCount[i] !== 'show' && !store.valueSearch[i]) {
                for (let j = 0; j < filterValues.length; j++) {
                    if (j < 5 || store.selected[i]?.includes(filterValues[j].url)) {
                        filteredValues.push(filterValues[j]);
                    } else if(j === 5) {
                        substract = true;
                        filteredValues.push({id: 'show_more', name: 'show_more', url: 'show_more'})
                    }
                }
            } else {
                filteredValues = filterValues;
            }
            values[i] = filteredValues.map((val) => {
                return {
                    value: val.url,
                    title: val.name,
                };
            });
            if (store.filterValueCount[i] !== 'show') {
                const allLength = props.filter[i].values.length;
                const visibleLength = values[i].length - ( substract ? 1 : 0);
                store.filterValueCount[i] = allLength !== visibleLength ? allLength - visibleLength : (store.valueSearch[i] ? 'show' : null);
            }
        }
    }
    return values;
});

const resetFilter = () => {
    store.selected = [];
    for (let i = 0; i < props.filter.length; i++) {
        if (props.filter[i].slider) {
            store.selected[i] = [props.filter[i].slider.min, props.filter[i].slider.max];
        }
    }
    changeFilter();
};

const removeFilter = (removeOptions) => {
    if ('value' in removeOptions) {
        store.selected[removeOptions.index] = store.selected[removeOptions.index].filter(item => item !== removeOptions.value);
    } else {
        store.selected[removeOptions.index] = removeOptions.default;
    }
    changeFilter();
};

watch(() => props.stock_filter, val => {
    if (val) {
        if (val.is_selected) {
            store.selectedStock = val.url;
        } else {
            store.selectedStock = null;
        }
    } else {
        store.selectedStock = null;
    }
}, { deep: true, immediate: true });

const changeRange = debounce(() => {
    changeFilter();
}, 300);

const changeFilter = () => {
    emit('changeFilter', buildFilterUrl(props.filter, url.value, store.selected, store.selectedStock));
};


defineExpose({
    removeFilter,
    resetFilter,
});
</script>

<style scoped lang="scss">
@use 'vuetify/lib/styles/settings/colors' as *;
@use 'sass:map';

.color-wrap {
    .v-btn:first-child {
        border-start-start-radius: 50%;
        border-end-start-radius: 50%;
    }

    .v-btn:last-child {
        border-start-end-radius: 50%;
        border-end-end-radius: 50%;
    }
}

::v-deep(.color-btn) {
    width: 1.8em !important;
    height: 1.8em !important;
    min-width: 1.8em;
    border-radius: 50%;
    box-shadow: 0 0 .1em grey;

    .v-btn__content {
        color: white !important;
        opacity: 0;
    }

    &.v-btn--active {
        box-shadow: 0 0 0 .2em white, 0 0 0 .3em map.get($green, base);

        .v-btn__overlay {
            opacity: 0.04 !important;
        }

        .v-btn__content {
            opacity: 1;
        }
    }
}

.tagsFilter {
    .v-checkbox {
        height: 3em;
    }
}

:deep(.c-filter-menu) {
    &, .v-autocomplete__content {
        width: 100%;
        box-shadow: none;
        position: static;
    }

    .v-list {
        padding-block: 0;
    }

    .v-list-item {
        padding-left: 0;
    }
}

:deep(.v-autocomplete--active-menu) {
    .v-autocomplete__menu-icon {
        transform: none;
    }
}

.c-floating-close {
    position: sticky;
    z-index: 1;
    bottom: 0;
}
</style>
